<template>
    <van-nav-bar title="Visitor's Info. Sheet(客户信息表)" style="margin-bottom: 20px" >
        <template #right>
<!--            <van-icon name="search" size="18" @click="this.$router.push({name:'CustomerQuery'})"/>-->
            <van-icon name="search" size="18" @click="cellSubmit"/>
        </template>
    </van-nav-bar>

    <van-steps :active="active" style="margin-bottom: 20px">
        <van-step>基本信息</van-step>
        <van-step>公司背景</van-step>
        <van-step>其他需求</van-step>
    </van-steps>
    <van-form @submit="onSubmit">
    <van-cell-group inset>
        <ul v-show="active==0">
            <van-row gutter="20">
                <van-col span="12">
                    <van-field
                        v-model="Customer_name"
                        name="Customer_name"
                        label-width="150"
                        input-align="right"
                        label="Customer Name (客户)"
                        placeholder="请输入客户名称"
                    />
                    <van-field v-model="date" name="date" label="Date (日期)" label-width="150" input-align="right" />
<!--                    <van-field v-model="time" name="time" label="Time (时间)" />-->
                    <van-field
                        v-model="Prepared_by"
                        name="Prepared_by"
                        label-width="150"
                        input-align="right"
                        label="Prepared by (操作人)"
                        placeholder="请输入操作人"
                    />
                    <van-space :size="20" style="margin-top: 10px;margin-left: 15px">
                        <van-button icon="plus" type="primary" size="small" @click="set_name()">储存</van-button>
                        <van-popover v-model:show="showPopover" :actions="Get_Name"  placement="right-start">
                            <van-cell v-for="text in Get_Name" :key="text" :title="text" @click="cell_name(text)">
                                <template #right-icon>
                                    <van-button icon="delete-o" type="danger" size="mini" style="margin-left: 15px" @click="delete_name(text)" />
                                </template>
                            </van-cell>
                            <template #reference>
                                <van-button icon="friends-o" type="primary" size="small" @click="get_name()">选择</van-button>
                            </template>
                        </van-popover>
                    </van-space>

                </van-col>
                <van-col span="2.1">
<!--                    <van-divider>Business Card Uploader (名片上传)</van-divider>-->
                    <van-uploader v-model="Business_card_z" name="Business_card_z" :after-read="card_z" :max-size="5000 * 1024" @oversize="onOversize"  :max-count="1" preview-size="100" upload-text="名片正面" @delete="upload_delete()"  style="margin-top: 20px">
                        <template #preview-cover="">
                            <div class="preview-cover van-ellipsis">名片正面</div>
                        </template>
                    </van-uploader>

                </van-col>
                <van-col span="2.1">
                    <van-uploader v-model="Business_card_f" name="Business_card_f" :after-read="card_f" :max-size="5000 * 1024" @oversize="onOversize" :max-count="1" preview-size="100" upload-text="名片背面" @delete="upload_delete()"  style="margin-top: 20px">
                        <template #preview-cover="">
                            <div class="preview-cover van-ellipsis">名片背面</div>
                        </template>
                    </van-uploader>
                </van-col>
            </van-row>
            <van-field name="Company_character" label="Company Character(公司性质)" label-align="top" >
                <template #input>
                    <van-checkbox-group v-model="Company_character" name="Company_character" direction="horizontal">
                        <van-checkbox name="0" shape="square" style="margin-bottom: 15px">Distributor (经销商)</van-checkbox>
                        <van-checkbox name="1" shape="square" style="margin-bottom: 15px">Wholesaler (批发商)</van-checkbox>
                        <van-checkbox name="2" shape="square" style="margin-bottom: 15px">Retailer (零售商)</van-checkbox>
                        <van-checkbox name="3" shape="square" style="margin-bottom: 15px">Manufacturer (制造商)</van-checkbox>
                        <van-checkbox name="4" shape="square" style="margin-bottom: 15px">Import & Export (进出口)</van-checkbox>
                        <van-checkbox name="5" shape="square" style="margin-bottom: 15px">Mass Merchant (大卖场)</van-checkbox>
                        <van-checkbox name="6" shape="square" style="margin-bottom: 15px">Projects (景观工程)</van-checkbox>
                        <van-field v-model="Company_others" name="Company_others" label="Others (其他)" label-width="100" placeholder="其他性质" />
                    </van-checkbox-group>

                </template>

            </van-field>
            <van-field name="Business_line" label="Business Line(产品范围)" label-align="top" >
                <template #input>
                    <van-checkbox-group v-model="Business_line" name="Business_line" direction="horizontal" >
                        <van-checkbox name="0" shape="square" style="margin-bottom: 15px">Umbrella (遮阳伞)</van-checkbox>
                        <van-checkbox name="1" shape="square" style="margin-bottom: 15px">Folding Tent (折叠篷)</van-checkbox>
                        <van-checkbox name="2" shape="square" style="margin-bottom: 15px">Pavilion (花园篷)</van-checkbox>
                        <van-checkbox name="3" shape="square" style="margin-bottom: 15px">Awning (窗篷)</van-checkbox>
                        <van-checkbox name="4" shape="square" style="margin-bottom: 15px">Pergola (凉棚）</van-checkbox>
                        <van-checkbox name="5" shape="square" style="margin-bottom: 15px">Furniture (家具)</van-checkbox>
                        <van-checkbox name="6" shape="square" style="margin-bottom: 15px">Base (伞座)</van-checkbox>
                        <van-checkbox name="7" shape="square" style="margin-bottom: 15px">Protective Cover (防尘套)</van-checkbox>
                        <van-checkbox name="8" shape="square" style="margin-bottom: 15px">Umbrella Light (伞灯)</van-checkbox>

                        <van-field v-model="Business_others" name="Business_others" label="Others (其他)" label-width="100" placeholder="其他范围" />
                    </van-checkbox-group>
                </template>
            </van-field >
        </ul>
        <ul v-show="active==1">
            <van-divider >Company Background(公司背景)</van-divider>
                <van-field
                    is-link
                    readonly
                    v-model="Which_country"
                    name="Which_country"
                    label="Which country (哪个国家)"
                    label-width="290"
                    input-align="right"
                    placeholder="点击选择国家"
                    @click="showArea = true"
                />
            <van-popup
                v-model:show="showArea"
                position="bottom"
                :style="{ height: '75%' }"
            >
                <van-nav-bar title="Which country (哪个国家)"  style="position:fixed;width: 100%" />
                <van-index-bar :sticky="false">
                    <ul v-for="vat in nation" :key="vat">
                        <van-index-anchor :index="vat" />
                        <ul v-for="vats in nationList[vat]" :key="vats">
                            <van-cell :title="vats.value" @click="Which_country = vats.value,showArea = false"/>
                        </ul>
                    </ul>
                </van-index-bar>
            </van-popup>
            <van-field
                name="Whether_a_group_company"
                label="Whether a group company (是否集团公司)"
                label-width="290"
                input-align="right"
                placeholder="顶部对齐"
            >
                <template  #input>
                    <van-radio-group v-model="Whether_a_group_company" name="Whether_a_group_company" direction="horizontal" shape="square">
                        <van-radio name="Y" @click="Whether_a_group_company='Y'">Yes(是)</van-radio>
                        <van-radio name="N" @click="Whether_a_group_company='N'">NO(否)</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
                <van-field
                    v-model="Annual_value_of_production"
                    name="Annual_value_of_production"
                    label="Annual value of production (产值)"
                    placeholder="产值"
                    label-width="290"
                    input-align="right"
                />
                <van-field
                    v-model="How_many_emplovee"
                    name="How_many_emplovee"
                    label="How many emplovee (人数)"
                    label-width="290"
                    placeholder="人数"
                    input-align="right"
                />
                <van-field
                    v-model="Factory_area"
                    name="Factory_area"
                    label="Factory area (厂房面积)"
                    label-width="290"
                    placeholder="厂房面积"
                    input-align="right"
                />
            <van-field
                v-model="Annual_purchasing_volume"
                name="Annual_purchasing_volume"
                label="Annual purchasing volume (年采购量)"
                label-width="290"
                input-align="right"
                placeholder="年采购量"
            />
            <van-field
                v-model="Product_range_pecentage"
                name="Product_range_pecentage"
                label="Product range(pecentage %)(产品范围,占比)"
                placeholder="产品范围，占比"
                label-width="290"
                input-align="right"
            />
            <van-field
                v-model="Career_experience"
                name="Career_experience"
                label="Career experience (行业经验)"
                placeholder="行业经验"
                label-align="top"
                autosize
                type="textarea"
                maxlength="500"
                show-word-limit
            />
            <van-field
                v-model="Product_market_positioning"
                name="Product_market_positioning"
                label="Product market positioning (产品市场定位)"
                placeholder="产品市场定位"
                label-align="top"
                autosize
                type="textarea"
                maxlength="500"
                show-word-limit
            />

            <van-field
                v-model="Sales_area"
                name="Sales_area"
                label="Sales area (销售区域)"
                placeholder="销售区域"
                label-align="top"
                autosize
                type="textarea"
                maxlength="500"
                show-word-limit
            />

            <van-field
                v-model="Suppliers"
                name="Suppliers"
                label="Suppliers (供应商)"
                placeholder="供应商"
                label-align="top"
                autosize
                type="textarea"
                maxlength="500"
                show-word-limit
            />
            <van-field
                v-model="Experience_with_china"
                name="Experience_with_china"
                label="Experience with China (做生意的经验)"
                placeholder="做生意的经验"
                label-align="top"
                autosize
                type="textarea"
                maxlength="500"
                show-word-limit
            />
            <van-field
                v-model="Cooperation_intention"
                name="Cooperation_intention"
                label="Cooperation intention (合作意向)"
                placeholder="合作意向"
                label-align="top"
                autosize
                type="textarea"
                maxlength="500"
                show-word-limit
            />

        </ul>
        <ul v-show="active==2">
            <van-field
                v-model="Need_quotations"
                name="Need_quotations"
                label="Need Quotations(报价需求)"
                placeholder="报价需求"
                label-align="top"
                autosize
                type="textarea"
                maxlength="500"
                show-word-limit
            />
            <van-field
                v-model="Need_samples"
                name="Need_samples"
                label="Need Samples(样品需求)"
                placeholder="样品需求"
                label-align="top"
                autosize
                type="textarea"
                maxlength="500"
                show-word-limit
            />
            <van-field
                v-model="Other_remarks"
                name="Other_remarks"
                label="Other Remarks(其他备注)"
                placeholder="其他备注"
                label-align="top"
                autosize
                type="textarea"
                maxlength="500"
                show-word-limit
            />
        </ul>
    </van-cell-group>

    <van-row justify="end" style="margin-top: 20px;margin-bottom: 150px">
        <van-col span="3" v-show="active>0">
            <van-button type="default" @click="steps_active('Y')" >上一步</van-button>
        </van-col>
        <van-col span="3" v-show="active<2">
            <van-button type="primary" @click="steps_active('N')" >下一步</van-button>
        </van-col>
        <van-col span="3" v-show="active>=2">
            <van-button type="success" block native-type="submit" style="right: 20px">提交信息</van-button>
        </van-col>
    </van-row>
    </van-form>
</template>
<script setup >
import {getCurrentInstance, ref, toRaw} from "vue";
    import nationList from "../json/nation";
import { showDialog, showFailToast, showLoadingToast, showSuccessToast, showToast} from "vant";
    import axios from "axios";
// eslint-disable-next-line no-unused-vars
import CustomerQuery from "@/components/CustomerQuery.vue";
import {useRouter} from "vue-router";
window.document.title = 'Customer Info'
    const {proxy} = getCurrentInstance()
    const showPopover = ref(false);
    const Set_Name = [];
    const Get_Name =ref([]);

    //国家选择框状态
    const showArea = ref(false);
    const router = useRouter();
    const cellSubmit = (id) => {
        console.log(id)
        router.push({path: '/CustomerQuery'})
    }
    /*
    * 表单变量
    * */
    //客户名称
    const Customer_name = ref('');
    //时间
    const date = ref(new Date().toLocaleDateString());
    //操作人
    const Prepared_by = ref()
    //产品性质
    const Company_character = ref([]);
    //产品性质其他
    const Company_others = ref();
    //产品范围
    const Business_line = ref([]);
    //产品范围其他
    const Business_others = ref();
    //哪个国家
    const Which_country = ref()
    //是否是集团公司
    const Whether_a_group_company = ref()
    //产值
    const Annual_value_of_production = ref()
    //人数
    const How_many_emplovee = ref()
    //厂房面积
    const Factory_area = ref()
    //年采购量
    const Annual_purchasing_volume = ref()
    //产品范围，占比
    const Product_range_pecentage = ref()
    //行业经验
    const Career_experience = ref()
    //产品市场定位
    const Product_market_positioning = ref()
    //销售区域
    const Sales_area = ref()
    //有哪些供应商
    const Suppliers = ref()
    //和中国做生意的经验
    const Experience_with_china = ref()
    //合作意向
    const Cooperation_intention = ref()
    //报价需求
    const Need_quotations = ref()
    //样品需求
    const Need_samples = ref()
    //其他备注
    const Other_remarks = ref()

    const Business_card_z = ref([]);
    const Business_card_f = ref([])

    const onOversize = (file) => {
        console.log(file);
        showToast('文件大小不能超过 5MB');
    };

    const card_z = (file) => {
        file.status = 'uploading';
        file.message = '上传中...';
        //axios.post(//"http://localhost:8002/lj/back/code_upload",
        axios.post("https://afa.activa-leisure.com/lj/back/code_upload",
            file,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then( result =>{
            //closeToast();
            if (result.data.success){
                Object.assign(Business_card_z.value,{url : result.data.url})
                setTimeout(() => {
                    file.status = 'done';
                    file.message = result.data.message;
                }, 1000);
            }else {
                setTimeout(() => {
                    file.status = 'failed';
                    file.message = result.data.message;
                }, 1000);
            }
        })

    };
    const upload_delete = (after) => {
        console.log(after)
    }
    const card_f = (file) => {
        file.status = 'uploading';
        file.message = '上传中...';
        axios.post("http://localhost:8002/lj/back/code_upload",
        //axios.post("https://afa.activa-leisure.com/lj/back/code_upload",
            file,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then(result => {

            if (result.data.success){
                Object.assign(Business_card_f.value,{url : result.data.url})
                setTimeout(() => {
                    file.status = 'done';
                    file.message = result.data.message;
                }, 1000);
            }else {
                setTimeout(() => {
                    file.status = 'failed';
                    file.message = result.data.message;
                }, 1000);
            }
        })
    }

    //默认操作人员赋值
    if (proxy.$cookies.get('Cell_Name') != null && proxy.$cookies.get('Cell_Name') != ''){
        Prepared_by.value = proxy.$cookies.get('Cell_Name')
    }
    //操作人员选择赋值
    if (proxy.$cookies.get('Set_Name') != null && proxy.$cookies.get('Set_Name') != ''){
        Set_Name.value = proxy.$cookies.get('Set_Name')
        for( let i = 0 ; i < Set_Name.value.length ; i++){
            Set_Name.push(Set_Name.value[i])
        }
    }
    //新增操作人员
    const set_name = () => {
        if (Prepared_by.value != null && Prepared_by.value != ''){
            if (Set_Name.indexOf(Prepared_by.value) == -1){
                Set_Name.push(Prepared_by.value)
                proxy.$cookies.set('Set_Name',Set_Name)
                showSuccessToast('储存成功！');
            }else {
                showDialog({
                    title: '错误提示',
                    message: '已存在相同的人员，储存失败！',
                }).then(() => {
                    // on close
                });
            }
        }else {
            showDialog({
                title: '错误提示',
                message: '操作人为空，储存失败！',
            }).then(() => {
                // on close
            });
        }

    }
    //赋值操作人员给侧拉框
    const get_name = () => {
        Get_Name.value = proxy.$cookies.get('Set_Name')
        if (Get_Name.value == null || Get_Name.value == ''){
            showFailToast('未储存人员！')
        }
    }
    //选择人员
    const cell_name = (name) => {
        Prepared_by.value = name
        proxy.$cookies.set('Cell_Name',name)
        showPopover.value = false
    }
    //删除人员
    const delete_name = (name) => {
        Get_Name.value.splice(Get_Name.value.indexOf(name),1)
        Set_Name.splice(Set_Name.indexOf(name),1)
        proxy.$cookies.set('Set_Name',Get_Name.value)
        showSuccessToast('删除成功！');
    }
    //国家排序数组
    const nation = ref(["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","Y","Z"])


    //下一步，上一步方法
    const active = ref(0);
    const steps_active = (state) => {
        if (state == 'Y'){
            if (active.value > 0){
                active.value--;
            }
        }else if (state == 'N'){
            if (active.value < 3){
                active.value++;
            }
        }

    }


    //提交方法
    const onSubmit = (values) => {

        Object.assign(values,
            { 'Company_character': JSON.stringify(toRaw(values.Company_character).join(',')) },
            { 'Business_line': JSON.stringify(toRaw(values.Business_line).join(',')) },
            { 'Business_card_z': toRaw(Business_card_z.value).url },
            { 'Business_card_f': toRaw(Business_card_f.value).url },
        )
        Object.assign(values,)
        console.log(values)
        showLoadingToast({
            overlay:true,
            forbidClick:true,
            message: '提交中...',
            duration:0
        });
        //axios.post("http://localhost:8002/lj/back/inst_customer",
        axios.post("https://afa.activa-leisure.com/lj/back/inst_customer",
            values,
            {
                headers:{
                    "content-type": "application/x-www-form-urlencoded"
                }
            }
        ).then( result =>{
           // closeToast();
            setTimeout(() => {
                if (result.data.success) {
                    Prepared_by.value = ""
                    //产品性质
                    Company_character.value = []
                    //产品性质其他
                    Company_others.value = ""
                    //产品范围
                    Business_line.value = []
                    //产品范围其他
                    Business_others.value = ""
                    //哪个国家
                    Which_country.value = ""
                    //是否是集团公司
                    Whether_a_group_company.value = ""
                    //产值
                    Annual_value_of_production.value = ""
                    //人数
                    How_many_emplovee.value = ""
                    //厂房面积
                    Factory_area.value = ""
                    //年采购量
                    Annual_purchasing_volume.value = ""
                    //产品范围，占比
                    Product_range_pecentage.value = ""
                    //行业经验
                    Career_experience.value = ""
                    //产品市场定位
                    Product_market_positioning.value = ""
                    //销售区域
                    Sales_area.value = ""
                    //有哪些供应商
                    Suppliers.value = ""
                    //和中国做生意的经验
                    Experience_with_china.value = ""
                    //合作意向
                    Cooperation_intention.value = ""
                    //报价需求
                    Need_quotations.value = ""
                    //样品需求
                    Need_samples.value = ""
                    //其他备注
                    Other_remarks.value = ""

                    Business_card_z.value = []
                    Business_card_f.value = []
                    active.value = 0
                    showSuccessToast(result.data.message);
                } else {
                    showFailToast(result.data.message);
                }
            },1000)
        })
       // console.log('submit', values);
    };
</script>
<style>
    .preview-cover {
        position: absolute;
        bottom: 0;
        box-sizing: border-box;
        width: 100%;
        padding: 4px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        background: rgba(0, 0, 0, 0.3);
    }
</style>